<template>
  <div>
    <productBanner />
    <div class="content">
      <div class="ins">
        <div class="title">疫苗安心接种服务平台</div>
        <div class="desc">疫苗安心接种服务平台一键式生成接种信息电子凭证，方便各方获取。</div>
        <div class="desc">采用数据桥接技术可将扫码获取的实际接种信息与接种点系统中的信息进行碰撞比对，人、苗信息一致方可进行接种。采用区块链加密技术，信息安全防篡改。</div>
        <div class="desc">符合新版《中华人民共和国疫苗管理法》的规定“告知接种信息”、“确保接种信息可追溯、可查询”；落实“三查七对一验证”，避免疫苗错种现象发生。</div>
        <div class="desc">部署简单，即插即用，可独立验证。</div>
        <div class="desc">适配各种网络和信息化环境，兼容各型号扫码枪、系统，可以和系统进行信息比对。支持数据导出和系统对接。</div>
        <div class="desc">语音播报和面板显示同步，百姓确认并能保留纸质和电子接种信息。</div>
      </div>
      <div class="img-container">
        <img src="~assets/images/products/product7.jpg" alt />
      </div>
    </div>
  </div>
</template>

<script>
import productBanner from "components/product-banner";
export default {
  components: {
    productBanner
  }
};
</script>

<style lang="stylus" scoped>
.content
  padding 80px 9%
  display flex
  .ins
    flex 1
    display flex
    flex-direction column
    .title
      line-height 70px
      color #0160B7
      font-size 30px
    .desc
      line-height 1.5
      font-size 14px
      color #333333
    img
      width 100%
      margin-top 10px
  .service
    margin-top 8%
    font-size 18px
    color #333333
    margin-bottom 10px
  .fun
    color #666666
    font-size 14px
  .list
    display flex
    justify-content space-between
    margin-top 22px
    .item
      line-height 58px
      width 32%
      font-size 14px
      text-align center
      border 1px dashed #287BFF
      background rgba(240, 246, 255, 1)
  .img-container
    flex 1
    img
      width 95%
      margin-left 5%
@media screen and (min-width: 1300px) and (max-width: 1550px)
  .service
    margin-top 3% !important
@media screen and (max-width: 1300px)
  .ins
    justify-content space-between
    .title
      line-height 1 !important
    .service
      margin-top 0 !important
</style>



// WEBPACK FOOTER //
// src/pages/ymjz/ymjz.vue